import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import checklist from "../../assets/icon/checklist.svg";
import checklistSize from "../../assets/icon/checklistSize.svg";
import FAQ from "../../component/FAQ/FAQ";

import bg from "../../assets/photo/aiservices.webp"

import "../../assets/style/AIServices.css"
import { useTranslation } from "react-i18next";

function AIServices(params) {
    const { t } = useTranslation();
    const listnlp = [
        "Chatbots & Virtual Assistants",
        "Text Classification & Summarization",
        "Sentiment Analysis"
    ] 
    
    const listcomputervision = [
        "Custom Image Classification",
        "Image Recognition & Similarity",
        "Optical Character Recognition (OCR)"
    ] 

    const listaudiointelligence = [
        "Voice Cloning",
        "Voice Separation & Enhancement"
    ] 
    
    const listpaml = [
        "Data Modeling & Forecasting",
        "Recommendation Systems",
        "Fraud Detection"
    ] 

    const listaiintegration = [
        "Integration with existing applications (ERP, CRM, Website)",
        "AI-driven Business Automation"
    ] 
    
    // const listwhy = [{
    //     title: "Expertise",
    //     text: t("aiservices1"),
    // },
    // {
    //     title: "Customization",
    //     text: t("aiservices2"),
    // },
    // {
    //     title: "Innovation",
    //     text: t("aiservices3"),
    // },
    // {
    //     title: "Scalability ",
    //     text: t("aiservices4"),
    // },
    // {
    //     title: "Support",
    //     text: t("aiservices5"),
    // }]

    return(
        <>
            <Topbar/>
        
            <section className='ai'>
                <div className='mainai'>
                    <img src="/photo/aiservices.webp" className='backgroundMainBig' alt="background" loading='eager' fetchPriority='high'/>
                    <div className='contentMainBig'>
                        <h1 className='white'>AI Services</h1>
                    </div>
                </div>
            </section>

            <section className="contentBig" style={{marginBottom: '18px'}}>
                <div className="width70">
                    <h1 style={{fontSize: '32px'}}>{t("ai1")}</h1>
                    <p className="textNormal">{t("ai2")}</p>
                
                    <p className="titleNormal">{t("ai22")}</p>
                    <p className="textNormal" >{t("ai3")}</p>

                    <p className="titleNormal">Natural Language Processing (NLP)</p>

                    {listnlp.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">Computer Vision</p>

                    {listcomputervision.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">Audio Intelligence</p>

                    {listaudiointelligence.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">Predictive Analytics & Machine Learning</p>

                    {listpaml.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                    <p className="titleNormal">AI Integration</p>

                    {listaiintegration.map((item, index) => (
                    <div key={index} className="itemBig" style={{marginBottom: '8px'}}>
                        <div className="dflex" alt="check">
                            <img src={checklist} alt="what?"/>
                        </div>
                        <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                    </div>
                    ))}

                     {/* <p className="titleNormal">{t("ai4")}</p>

                    {listwhy.map((item, index) => (
                    <div key={index} className="itemWhy">
                        <div className="dflex">
                            <img src={checklistSize} alt="check"/>
                        </div>
                        <div>
                        <h2 className="titleItemWhyBig">{item.title}</h2>
                        <h2 className="textItemWhyBig">{item.text}</h2>
                        </div>
                    </div> */}
                    {/* ))} */}
                </div>

                <div className="cardSoftware">
                    <p className="titleHigh">{t("sidecardtitle")}</p>
                    <p className="textNormal mb64">{t("sidecardtext")}</p>
                    <div>
                        <button className="buttonBlack" onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                    </div>
                </div>
            </section>

<body className="card">
  <h2>{t("aigridtitle")}</h2>
  <p class="subtitle">{t("aigridtext")}</p>

  <div class="workflow" style={{paddingBottom: '0px'}}>

    <div class="step">
      <div class="step-number">1</div>
      <div class="step-title">{t("aigridtitle1")}</div>
      <div class="step-desc">{t("aigridtext1")}</div>
    </div>
    <div class="step">
      <div class="step-number">2</div>
      <div class="step-title">{t("aigridtitle2")}</div>
      <div class="step-desc">{t("aigridtext2")}</div>
    </div>
    <div class="step">
      <div class="step-number">3</div>
      <div class="step-title">{t("aigridtitle3")}</div>
      <div class="step-desc">{t("aigridtext3")}</div>
    </div>
    <div class="step">
      <div class="step-number">4</div>
      <div class="step-title">{t("aigridtitle4")}</div>
      <div class="step-desc">{t("aigridtext4")}</div>
    </div>
    <div class="step">
      <div class="step-number">5</div>
      <div class="step-title">{t("aigridtitle5")}</div>
      <div class="step-desc">{t("aigridtext5")}</div>
    </div>
    <div class="step">
      <div class="step-number">6</div>
      <div class="step-title">{t("aigridtitle6")}</div>
      <div class="step-desc">{t("aigridtext6")}</div>
    </div>

  </div>
</body>

            <FAQ/>
            <Footer/>
        </>
    )
}

export default AIServices